import { store } from '@/store/store'
import TokensCheck from './tokensCheck'

export default (to, from, next) => {
  var model = store.state.model;
  var user = store.state.user;
  var isLogged = Boolean(model.isLogged());
  var isTokensCheck = TokensCheck.getTokensCheck();

  // Si toutes les conditions sont remplies, alors on passe à la suite, 
  // sinon on logout() et on reviens à la page de connexion
  if (model && isLogged && isTokensCheck) {

    next()

  } else {

    // console.log('🛑🛑🛑-authGuard-connectError');
    this.errorMsg = "need reconnection";
    // model.logout(1,user);
    next({name: 'connect'});

  }
}



// WEBPACK FOOTER //
// ./src/router/authGuard.js